import { Component } from '@angular/core';
import { IonicPage, NavController, LoadingController, NavParams } from 'ionic-angular';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthProvider } from "../../providers/auth/auth";
import { SERVER_URL } from "../../config";
import { CategoriemenuPage } from '../categoriemenu/categoriemenu';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { FileUploader } from 'ng2-file-upload';
import { Storage } from "@ionic/storage";
const URL = SERVER_URL + '/categorieMenu/newCategoriaMenuImg';

/**
 * Generated class for the AddcategoriamenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-addcategoriamenu',
  templateUrl: 'addcategoriamenu.html',
})
export class AddcategoriamenuPage {
  aut;
  uploader: FileUploader;
  carpeta = "";
  indice = 0;
  jwt;
  values: any;
  errorMessage;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    private readonly loadingCtrl: LoadingController,
    private readonly httpClient: HttpClient,
    authProvider: AuthProvider,
    private readonly storage: Storage,

    public rest: RestApiProvider
  ) {
    this.aut = authProvider;
    this.storage.get('jwt_token').then((value) => {
      this.jwt = value;
      console.log(" jwt_tokennnnnnnnnnnnn:" + this.jwt)

    })
  }

  openFileDialog1 = function () {
    document.getElementById('seleccion').click();
    this.filecreate();

    /*
     if (this.carpeta.length < 5) {
         alert("El nombre de carpeta no ha sido especificado o no se trata de un nombre valido.");
     } else {
         document.getElementById('seleccion').click();
     }
     */
  };
  filecreate() {

    console.log("filecreate new Fileuploader:" + this.jwt)
    this.uploader = new FileUploader({
      authToken: 'Bearer ' + this.jwt,
      url: URL, // url del php que trata el fichero subido
      method: 'POST',
      removeAfterUpload: true, // lo quita de la lista una vez su subida fue correcta
      queueLimit: 100 // limite de archivos que se pueden añadir a la lista, si el numero de archivos seleccionados es superior se cogen los x primeros.
    });

    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      console.log("uploader.onBuildItemForm")

      form.append('categoriaMenuString', JSON.stringify(this.values));

      form.append('id', this.indice);
      form.append('fotonum', 'n1');
      form.append('carpeta', this.carpeta);
      this.indice = this.indice + 1;
    };
    // Función que salta cada vez que añadimos un nuevo archivo, aqui podemos controlar que no se suban archivos demasiado grandes
    this.uploader.onAfterAddingFile = function (fileItem) {
      if (fileItem.file.size > 5242880) {
        alert("Il file non deve supere 5 MB");


        fileItem.cancel();
        fileItem.remove();
      }
      fileItem.withCredentials = false;
      console.info('onAfterAddingFile', fileItem);
    };
    // Función que salta cuando se han añadido todos los archivos seleccionados.
    this.uploader.onAfterAddingAll = function (addedFileItems) {
      console.info('onAfterAddingAll');
    };
    // Función que se ejecuta antes de subir un archivo. Aquí añadimos datos adicionales necesarios para renombrar el
    // archivo como nosotros queremos.
    this.uploader.onBeforeUploadItem = function (item) {

      console.info('onBeforeUploadItem');

    };
    // Barra de progreso que indica la subida.
    this.uploader.onProgressItem = function (fileItem, progress) {
      console.info('onProgressItem');
    };
    // Función que se ejecuta cuando la barra de progreso llega a su fin.
    this.uploader.onProgressAll = function (progress) {
      console.info('onProgressAll');
    };
    // Función que salta si la subida del archivo se produjo con éxito en nuestro caso guardamos los índices de las
    // imágenes para almacenarlos posteriormente en la bdd.
    this.uploader.onSuccessItem = function (fileItem, response, status, headers) {
      alert(response);

      console.info('onSuccessItem', fileItem, response, status, headers);

    };
    // Función que salta si se produce un error en la subida.
    this.uploader.onErrorItem = function (fileItem, response, status, headers) {
      console.info('onErrorItem', fileItem, response, status, headers);
    };
    // Función que se ejecuta si se cancela la subida.
    this.uploader.onCancelItem = function (fileItem, response, status, headers) {
      console.info('onCancelItem', fileItem, response, status, headers);
    };

    this.uploader.onCompleteItem = function (fileItem, response, status, headers) {
      console.info('onCompleteItem');
    };
    this.uploader.onCompleteAll = function () {
      console.info('onCompleteAll');
    };

  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad AddcategoriaPage');
  }
  newCategoriaMenu(values: any) {
    this.values = values;
    let loading = this.loadingCtrl.create({

      spinner: 'bubbles',
      duration: 4000,

      content: 'save categoria ...'

    });

    loading.present();

    console.log(values)

    console.log(JSON.stringify(values));


    let headers = this.aut.getHttpHeaders();
    if (this.uploader == null || this.uploader.queue == null)
      this.rest.nuovaCategoriaMenu(values).subscribe(
        res => {
          //alert(JSON.stringify(res))
          this.navCtrl.push(CategoriemenuPage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });

        },
        error => this.errorMessage = <any>error);
    else if (this.uploader != null && this.uploader.queue != null) {
      this.uploader.queue[0].upload();

      let hideFooterTimeout1 = setTimeout(() => {
        //   loading.dismiss();
        this.navCtrl.push(CategoriemenuPage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });

      }, 5000);
    }



  }


}



// WEBPACK FOOTER //
// ./src/pages/addcategoriamenu/addcategoriamenu.ts